import { apiService } from '@/services/api';
import type { LiveSyncState } from '../types';

export const liveSyncApi = {
    getStatus: async (tableId: string): Promise<LiveSyncState> => {
        interface LiveSyncBackendResponse {
            is_active: boolean;
            content_url?: string;
            embed_code?: string;
            broadcast_type: 'phet' | 'video' | 'custom';
            updated_at?: string;
        }

        const response = await apiService.request<LiveSyncBackendResponse>(`/modules/livesync/table/${tableId}`, {
            method: 'GET'
        });
        return {
            isActive: response.is_active,
            contentUrl: response.content_url,
            embedCode: response.embed_code,
            broadcastType: response.broadcast_type,
            updatedAt: response.updated_at
        };
    },

    startLiveSync: async (tableId: string, data: { url?: string, embedCode?: string, type: string }) => {
        return await apiService.request(`/modules/livesync/table/${tableId}/start`, {
            method: 'POST',
            body: JSON.stringify({
                url: data.url,
                embed_code: data.embedCode,
                sync_type: data.type
            })
        });
    },

    stopLiveSync: async (tableId: string) => {
        return await apiService.request(`/modules/livesync/table/${tableId}/stop`, {
            method: 'POST'
        });
    }
};
